import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "m-4 px-4 sm:px-6 lg:px-8" };
const _hoisted_2 = { class: "sm:flex sm:items-center" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("div", { class: "sm:flex-auto" }, [
    /*#__PURE__*/ _createElementVNode("h1", { class: "text-xl font-semibold text-gray-900" }, "All My Requests"),
    /*#__PURE__*/ _createTextVNode(),
    /*#__PURE__*/ _createElementVNode("p", { class: "mt-2 text-sm text-gray-700" }, "A list of all my requests.")
], -1);
const _hoisted_4 = { class: "mt-4 sm:mt-0 sm:ml-16 sm:flex-none" };
const _hoisted_5 = { class: "mt-8 flex flex-col md:flex-row justify-end" };
const _hoisted_6 = { class: "mt-2" };
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("label", {
    for: "filter-doctype",
    class: "text-gray-600"
}, "Doctype:", -1);
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("option", { value: "STARTER" }, "Starters", -1);
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("option", { value: "LEAVER" }, "Leavers", -1);
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("option", { value: "AMEND" }, "Amends", -1);
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("option", { value: "OFFER" }, "Offers", -1);
const _hoisted_12 = { class: "mt-2 md:ml-2" };
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("label", {
    for: "filter-doctype",
    class: "text-gray-600"
}, "Stage:", -1);
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("option", { value: "all" }, "All", -1);
const _hoisted_15 = ["value"];
const _hoisted_16 = { class: "mt-8 flex flex-col" };
const _hoisted_17 = { class: "-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8" };
const _hoisted_18 = { class: "inline-block min-w-full py-2 align-middle md:px-6 lg:px-8" };
const _hoisted_19 = { class: "overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg" };
const _hoisted_20 = { class: "min-w-full divide-y divide-gray-300" };
const _hoisted_21 = /*#__PURE__*/ _createElementVNode("thead", { class: "bg-gray-50" }, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", {
            scope: "col",
            class: "py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
        }, "\n                    Short ID\n                  "),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", {
            scope: "col",
            class: "px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
        }, "\n                    Role\n                  "),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", {
            scope: "col",
            class: "px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
        }, "\n                    Company Code\n                  "),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", {
            scope: "col",
            class: "px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
        }, "\n                    Employee Name\n                  "),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", {
            scope: "col",
            class: "px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
        }, "\n                    Assigned to\n                  "),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", {
            scope: "col",
            class: "px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
        }, "\n                    Current stage\n                  ")
    ])
], -1);
const _hoisted_22 = {
    key: 0,
    class: "bg-white"
};
const _hoisted_23 = { class: "whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6" };
const _hoisted_24 = { class: "flex w-full items-center justify-between gap-1" };
const _hoisted_25 = ["onClick"];
const _hoisted_26 = { class: "whitespace-nowrap px-3 py-4 text-sm text-gray-500" };
const _hoisted_27 = { key: 0 };
const _hoisted_28 = { key: 1 };
const _hoisted_29 = { class: "whitespace-nowrap px-3 py-4 text-sm text-gray-500" };
const _hoisted_30 = { class: "whitespace-nowrap px-3 py-4 text-sm text-gray-500" };
const _hoisted_31 = { class: "whitespace-nowrap px-3 py-4 text-sm text-gray-500" };
const _hoisted_32 = { class: "whitespace-nowrap px-3 py-4 text-sm text-gray-500" };
const _hoisted_33 = {
    key: 0,
    class: "text-gray-400 text-center p-8"
};
import { computed, inject, nextTick, onActivated, onDeactivated, onMounted, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import AmendmentTypeIcon from '@/components/dashboard/amendment-type-icon.vue';
import { consumeSidebarDashboardReset, filtersFromQuery, peekSidebarDashboardReset, queryHasDashboardFilters, replaceDashboardQuery, resolveDashboardFilters, } from '@/helpers/dashboard-query';
import { getCompanyCode } from '@/helpers/get-company-code';
import httpClient from '@/httpClient';
import { clearStorage } from '@/storageSave';
const DASHBOARD_PATH = '/all-my-documents';
export default /*#__PURE__*/ _defineComponent({
    ...{
        name: 'AllDocuments',
    },
    __name: 'allDocuments',
    setup(__props) {
        const FILTER_DEFAULTS = {
            'doc-type': 'STARTER',
            stage: 'all',
        };
        const store = useStore();
        const router = useRouter();
        const route = useRoute();
        const atrs = ref([]);
        const loaded = ref(false);
        const isFirstActivation = ref(true);
        const isDashboardActive = ref(true);
        const suppressQueryWatch = ref(false);
        const doctype = ref(FILTER_DEFAULTS['doc-type']);
        const stage = ref(FILTER_DEFAULTS.stage);
        const pageNumber = ref(0);
        const atEnd = ref(false);
        const tokens = ref(['']);
        const routes = {
            STARTER: 'view-starter',
            LEAVER: 'view-leaver',
            AMEND: 'view-amend',
            OFFER: 'view-offer',
        };
        const stages = inject('stages', []);
        const currentFilters = () => ({
            'doc-type': doctype.value,
            stage: stage.value,
        });
        const applyFilters = async (filters) => {
            suppressQueryWatch.value = true;
            doctype.value = filters['doc-type'] ?? FILTER_DEFAULTS['doc-type'];
            stage.value = filters.stage ?? FILTER_DEFAULTS.stage;
            await nextTick();
            suppressQueryWatch.value = false;
        };
        const resetPagination = () => {
            pageNumber.value = 0;
            atEnd.value = false;
            tokens.value = [''];
        };
        const syncFiltersToRoute = async () => {
            suppressQueryWatch.value = true;
            try {
                await replaceDashboardQuery(router, DASHBOARD_PATH, currentFilters(), FILTER_DEFAULTS, route.query);
            }
            finally {
                await nextTick();
                suppressQueryWatch.value = false;
            }
        };
        const filtersMatch = (filters) => filters['doc-type'] === doctype.value && filters.stage === stage.value;
        const navigateNewDoc = (docType) => {
            // clear storage
            if (docType.toUpperCase() === 'STARTER') {
                clearStorage('atrShortId');
                clearStorage('atrId');
                clearStorage('formData');
            }
            if (docType.toUpperCase() === 'AMEND') {
                clearStorage('amendsFormData');
            }
            if (docType.toUpperCase() === 'LEAVER') {
                store.dispatch('leaverForm/clearAllLeaverFormData');
                clearStorage('leaverShortId');
                clearStorage('leaverForm');
            }
            const routeMap = {
                starter: '/create-starter/new-atr',
                amend: '/create-amend',
                leaver: '/create-leaver/new-leaver',
            };
            router.push(routeMap[docType]);
        };
        const stagesOptions = computed(() => stages.filter((stage) => stage.type === doctype.value.toLowerCase()));
        const findStage = (stageName, status) => {
            const foundStage = stages.find((stage) => stage.stageName === stageName);
            if (foundStage)
                return foundStage.displayName;
            return status === 'DRAFT' ? 'Work in progress' : status;
        };
        const showAmendmentTypeIcon = (atr) => {
            const amendmentType = atr.formThree?.amendmentType;
            const stagesWithAmendmentTypeIcon = [
                'amend.notifyAmendH2R',
                'amend.notifyAmendH2RAdminUpdated',
            ];
            return (doctype.value === 'AMEND' &&
                stagesWithAmendmentTypeIcon.includes(stage.value) &&
                Array.isArray(amendmentType) &&
                amendmentType.length > 0);
        };
        const navigateToDocument = async (id, docOwner) => {
            // find document
            const document = atrs.value.find((atr) => atr.docId === id);
            if (document && document.currentStageName === 'starter.notifyRecruitment') {
                router.push({ path: `/recruitment-team/${id}/${docOwner}` });
            }
            else if (document &&
                document.currentStageName === 'starter.notifyRecruitmentUpdated') {
                router.push({ path: `/recruitment-update/${id}/${docOwner}` });
            }
            else if (document &&
                document.currentStageName === 'starter.notifyRoleAdvertised') {
                router.push({ path: `/advert-raised/${id}/${docOwner}` });
            }
            else if (document &&
                document.currentStageName === 'starter.notifyCVsCollected') {
                router.push({ path: `/ready-for-selection/${id}/${docOwner}` });
            }
            else if (document &&
                (document.currentStageName === 'starter.notifyCandidateSelected' ||
                    document.currentStageName === 'starter.complete')) {
                router.push({ path: `/selection-complete/${id}/${docOwner}` });
            }
            else if (document &&
                document.currentStageName === 'offer.notifyMakeOffer') {
                router.push({ path: `/offer-hr/${id}/${docOwner}` });
            }
            else if (document &&
                document.currentStageName === 'offer.notifyPrepOffer') {
                router.push({ path: `/confirm/${id}/${docOwner}` });
            }
            else if (document &&
                document.currentStageName === 'offer.notifyTermsHaveChanged') {
                router.push({ path: `/amend-terms/${id}/${docOwner}` });
            }
            else if (document && document.currentStageName === 'offer.notifyH2RAdmin') {
                router.push({ path: `/assign-admin-owner/${id}/${docOwner}` });
            }
            else if (document &&
                document.currentStageName === 'offer.notifyOfferSent') {
                router.push({ path: `/sap-confirmation/${id}/${docOwner}` });
            }
            else {
                router.push({ path: `/${routes[doctype.value]}/${id}/${docOwner}` });
            }
        };
        const currentAssigneeEmail = (atr) => {
            if (atr.currentAssigneeEmail) {
                if (atr.currentAssigneeEmail.includes('@')) {
                    return atr.currentAssigneeEmail;
                }
                if (atr.currentAssignee?.includes('@')) {
                    return atr.currentAssignee;
                }
                return atr.currentAssigneeEmail;
            }
            return 'Unassigned';
        };
        const fetchAtrs = async (type = 'next') => {
            const url = '/bff/list-mydocs-by-doctype';
            const token = type === 'next'
                ? tokens.value[pageNumber.value]
                : tokens.value[pageNumber.value - 2];
            const response = await httpClient.post(url, {
                requestedBy: '12345678910',
                docType: doctype.value,
                stage: stage.value,
                next: token ? token : undefined,
            });
            if (type === 'next') {
                pageNumber.value++;
            }
            if (type === 'prev') {
                pageNumber.value--;
            }
            if (!response.data.body.next) {
                atEnd.value = true;
            }
            else {
                atEnd.value = false;
                tokens.value.push(response.data.body.next);
            }
            atrs.value = response.data.body?.Items ?? [];
        };
        /** Refetch the current cursor page without changing filters or page state. */
        const refetchCurrentPage = async () => {
            if (pageNumber.value < 1) {
                return;
            }
            const token = tokens.value[pageNumber.value - 1];
            const response = await httpClient.post('/bff/list-mydocs-by-doctype', {
                requestedBy: '12345678910',
                docType: doctype.value,
                stage: stage.value,
                next: token ? token : undefined,
            });
            atrs.value = response.data.body?.Items ?? [];
            // Drop any cursors beyond the current page so Next cannot use a stale token.
            tokens.value = tokens.value.slice(0, pageNumber.value);
            if (!response.data.body.next) {
                atEnd.value = true;
            }
            else {
                atEnd.value = false;
                tokens.value[pageNumber.value] = response.data.body.next;
            }
        };
        const nextPage = async () => {
            if (atEnd.value)
                return;
            store.dispatch('setIsLoading', true);
            await fetchAtrs();
            store.dispatch('setIsLoading', false);
        };
        const prevPage = async () => {
            if (pageNumber.value === 1)
                return;
            store.dispatch('setIsLoading', true);
            await fetchAtrs('prev');
            store.dispatch('setIsLoading', false);
        };
        const fetchFirstPageWithLoading = async () => {
            store.dispatch('setIsLoading', true);
            resetPagination();
            await fetchAtrs();
            store.dispatch('setIsLoading', false);
        };
        const applySidebarReset = async () => {
            if (!consumeSidebarDashboardReset(DASHBOARD_PATH)) {
                return false;
            }
            await applyFilters(FILTER_DEFAULTS);
            await fetchFirstPageWithLoading();
            return true;
        };
        onMounted(async () => {
            store.dispatch('setIsLoading', true);
            const { filters } = await resolveDashboardFilters(router, DASHBOARD_PATH, route.query, FILTER_DEFAULTS);
            await applyFilters(filters);
            resetPagination();
            await fetchAtrs();
            store.dispatch('setIsLoading', false);
            loaded.value = true;
        });
        onActivated(async () => {
            isDashboardActive.value = true;
            if (isFirstActivation.value) {
                isFirstActivation.value = false;
                return;
            }
            if (route.path !== DASHBOARD_PATH) {
                return;
            }
            if (await applySidebarReset()) {
                return;
            }
            await refetchCurrentPage();
        });
        onDeactivated(() => {
            isDashboardActive.value = false;
        });
        watch(doctype, async () => {
            if (suppressQueryWatch.value) {
                return;
            }
            suppressQueryWatch.value = true;
            stage.value = FILTER_DEFAULTS.stage;
            await nextTick();
            suppressQueryWatch.value = false;
            await syncFiltersToRoute();
            await fetchFirstPageWithLoading();
        });
        watch(stage, async () => {
            if (suppressQueryWatch.value) {
                return;
            }
            await syncFiltersToRoute();
            await fetchFirstPageWithLoading();
        });
        watch(() => route.query, async () => {
            if (suppressQueryWatch.value || route.path !== DASHBOARD_PATH) {
                return;
            }
            if (!isDashboardActive.value) {
                return;
            }
            if (queryHasDashboardFilters(route.query, FILTER_DEFAULTS)) {
                const fromUrl = filtersFromQuery(route.query, FILTER_DEFAULTS);
                if (filtersMatch(fromUrl)) {
                    return;
                }
                await applyFilters(fromUrl);
                await fetchFirstPageWithLoading();
                return;
            }
            if (peekSidebarDashboardReset(DASHBOARD_PATH) && (await applySidebarReset())) {
                return;
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _hoisted_3,
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("button", {
                            type: "button",
                            class: "inline-flex items-center justify-center rounded-md border border-transparent bg-green-700 hover:bg-green-800 hover:underline px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-green-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto ml-2",
                            onClick: _cache[0] || (_cache[0] = ($event) => (navigateNewDoc('amend')))
                        }, "\n          Create Amendment\n        "),
                        _createTextVNode(),
                        _createElementVNode("button", {
                            type: "button",
                            class: "inline-flex items-center justify-center rounded-md border border-transparent bg-green-700 hover:bg-green-800 hover:underline px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-green-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto ml-2",
                            onClick: _cache[1] || (_cache[1] = ($event) => (navigateNewDoc('leaver')))
                        }, "\n          Create Leaver\n        ")
                    ])
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                        _hoisted_7,
                        _createTextVNode(),
                        _withDirectives(_createElementVNode("select", {
                            id: "filter-doctype-select",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((doctype).value = $event)),
                            name: "filter-doctype",
                            class: "w-full mt-1 focus:ring-indigo-500 focus:border-indigo-500 block shadow-sm sm:text-sm border-gray-300 rounded-md"
                        }, [
                            _hoisted_8,
                            _createTextVNode(),
                            _hoisted_9,
                            _createTextVNode(),
                            _hoisted_10,
                            _createTextVNode(),
                            _hoisted_11
                        ], 512), [
                            [_vModelSelect, doctype.value]
                        ])
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_12, [
                        _hoisted_13,
                        _createTextVNode(),
                        _withDirectives(_createElementVNode("select", {
                            id: "filter-stage-select",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((stage).value = $event)),
                            name: "filter-stage",
                            class: "w-full mt-1 focus:ring-indigo-500 focus:border-indigo-500 block shadow-sm sm:text-sm border-gray-300 rounded-md"
                        }, [
                            _hoisted_14,
                            _createTextVNode(),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stagesOptions.value, (stageItem) => {
                                return (_openBlock(), _createElementBlock("option", {
                                    key: stageItem.stageName,
                                    value: stageItem.stageName
                                }, _toDisplayString(stageItem.displayName), 9, _hoisted_15));
                            }), 128))
                        ], 512), [
                            [_vModelSelect, stage.value]
                        ])
                    ])
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                                _createElementVNode("table", _hoisted_20, [
                                    _hoisted_21,
                                    _createTextVNode(),
                                    (atrs.value.length)
                                        ? (_openBlock(), _createElementBlock("tbody", _hoisted_22, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(atrs.value, (atr, index) => {
                                                return (_openBlock(), _createElementBlock("tr", {
                                                    key: atr.docId,
                                                    class: _normalizeClass(index % 2 === 0 ? undefined : 'bg-gray-50')
                                                }, [
                                                    _createElementVNode("td", _hoisted_23, [
                                                        _createElementVNode("span", _hoisted_24, [
                                                            _createElementVNode("span", {
                                                                class: "text-blue-600 hover:underline cursor-pointer",
                                                                onClick: ($event) => (navigateToDocument(atr.docId, atr.requestedBy))
                                                            }, _toDisplayString(atr.shortId), 9, _hoisted_25),
                                                            _createTextVNode(),
                                                            (showAmendmentTypeIcon(atr))
                                                                ? (_openBlock(), _createBlock(AmendmentTypeIcon, {
                                                                    key: 0,
                                                                    "short-id": atr.shortId,
                                                                    "amendment-types": atr.formThree?.amendmentType ?? []
                                                                }, null, 8, ["short-id", "amendment-types"]))
                                                                : _createCommentVNode("", true)
                                                        ])
                                                    ]),
                                                    _createTextVNode(),
                                                    _createElementVNode("td", _hoisted_26, [
                                                        (doctype.value === 'OFFER')
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(atr.atr?.formThree?.jobTitle
                                                                ? atr.atr.formThree.jobTitle
                                                                : "No role specified"), 1))
                                                            : (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(atr.formThree?.jobTitle
                                                                ? atr.formThree.jobTitle
                                                                : "No role specified"), 1))
                                                    ]),
                                                    _createTextVNode(),
                                                    _createElementVNode("td", _hoisted_29, _toDisplayString(_unref(getCompanyCode)(atr)), 1),
                                                    _createTextVNode(),
                                                    _createElementVNode("td", _hoisted_30, _toDisplayString(atr?.docType === "STARTER"
                                                        ? "N/A"
                                                        : atr?.formTwo?.employee_name
                                                            ? atr?.formTwo?.employee_name
                                                            : atr?.formTwo?.employeeName
                                                                ? atr?.formTwo?.employeeName
                                                                : atr?.candidate?.firstName
                                                                    ? atr?.candidate?.firstName +
                                                                        " " +
                                                                        atr?.candidate?.surname
                                                                    : atr?.candidate?.internalCandidateName
                                                                        ? atr?.candidate?.internalCandidateName
                                                                        : "N/A"), 1),
                                                    _createTextVNode(),
                                                    _createElementVNode("td", _hoisted_31, _toDisplayString(currentAssigneeEmail(atr)), 1),
                                                    _createTextVNode(),
                                                    _createElementVNode("td", _hoisted_32, _toDisplayString(findStage(atr.currentStageName, atr.status)), 1)
                                                ], 2));
                                            }), 128))
                                        ]))
                                        : _createCommentVNode("", true)
                                ]),
                                _createTextVNode(),
                                (loaded.value && !atrs.value.length)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_33, "\n              No Requests to show...\n            "))
                                    : _createCommentVNode("", true)
                            ])
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", { class: "flex justify-center md:justify-end mx-1 md:mx-8 my-4 px-4 md:px-8 py-4 shadow rounded ring-1 ring-black ring-opacity-5" }, [
                            _createElementVNode("button", {
                                class: "ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-green-700 bg-white hover:bg-gray-50 disabled:opacity-25 disabled:text-gray-600 disabled:cursor-not-allowed",
                                onClick: prevPage
                            }, "\n            Prev\n          "),
                            _createTextVNode(),
                            _createElementVNode("button", {
                                class: "ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-green-700 bg-white hover:bg-gray-50 disabled:opacity-25 disabled:text-gray-600 disabled:cursor-not-allowed",
                                onClick: nextPage
                            }, "\n            Next\n          ")
                        ])
                    ])
                ])
            ]));
        };
    }
});
